export default "__VITE_ASSET__Ckpxjlji__"